import { FileFormat } from '@/graphql/generated/types.generated';

/**
    Determines possible file type via extension of the file url
*/
export const getFileFormatByExtension = (fileUrl: string): FileFormat | undefined => {
    try {
        const { pathname } = new URL(fileUrl);
        return getFileExtensionPath(pathname);
    } catch {
        // Invalid URL try to get as path
        return getFileExtensionPath(fileUrl);
    }
};

const getFileExtensionPath = (filePath: string): FileFormat | undefined => {
    const extension = filePath.slice(filePath.lastIndexOf('.')).toLowerCase();

    const videoExtensions = new Set(['.mp4', '.webm', '.mov']);
    const imageExtensions = new Set(['.jpg', '.jpeg', '.png', '.webp', '.heif']);

    if (videoExtensions.has(extension)) {
        return FileFormat.Video;
    }

    if (imageExtensions.has(extension)) {
        return FileFormat.Image;
    }

    return undefined;
};
